// extracted by mini-css-extract-plugin
export var hero = "style-module--hero--bff25";
export var hero__bage = "style-module--hero__bage--5ab14";
export var hero__btn = "style-module--hero__btn--c2e8e";
export var hero__btnMain = "style-module--hero__btn--main--f9631";
export var hero__btnSimple = "style-module--hero__btn--simple--8e933";
export var hero__btns = "style-module--hero__btns--ef22c";
export var hero__details = "style-module--hero__details--79222";
export var hero__detailsItem = "style-module--hero__details-item--facc4";
export var hero__detailsItemFour = "style-module--hero__details-item--four--c57f0";
export var hero__detailsItemOne = "style-module--hero__details-item--one--839f9";
export var hero__detailsItemThree = "style-module--hero__details-item--three--84cde";
export var hero__detailsItemTwo = "style-module--hero__details-item--two--eb826";
export var hero__img = "style-module--hero__img--b852a";
export var hero__info = "style-module--hero__info--1c028";
export var hero__text = "style-module--hero__text--589c7";
export var hero__title = "style-module--hero__title--e2a3f";
export var rocket = "style-module--rocket--71ff9";